const fetchIncidentResponseTime = () => {
  const incidentResponseTime = '214 min';
  return { type: 'INCIDENT_RESPONSE_TIME', payload: { incidentResponseTime } };
};

export default fetchIncidentResponseTime;
